import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import '../base.css';
import PricingTable from '../components/pricing/PricingTable';
import UserLocationContext from '../components/user-location/UserLocationContext';

export default () => {
    const { t } = useTranslation();
    const userLocation = useContext(UserLocationContext);
    return (
        <main>
            <header className="wrapper text-center pt-8">
                <h1>{t('title_pricing', { defaultValue: 'Pricing' })}</h1>
                <p>
                    {t('pricing_desc', {
                        defaultValue: 'Simple transparent pricing for all sizes of farm.',
                    })}
                </p>
            </header>
            <PricingTable userLocation={userLocation} />
        </main>
    );
};
